export const actTypeOptions = [
  { value: 'headline', label: 'Headliner' },
  { value: 'support', label: 'Support' },
];
